import { Slot } from 'expo-router';
import React from 'react';

import { AuthGate } from '@/components/AuthGate';
import { NavigationGate } from '@/components/NavigationGate';

export default function MainLayout() {
  return (
    <AuthGate>
      <NavigationGate>
        <Slot />
      </NavigationGate>
    </AuthGate>
  );
} 